/**
 * @file        themeToggle.component.ts
 * @description Shared header control for light and dark modes
 */
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ThemeService } from '@app/service/theme.service';

@Component
({
    selector: 'app-theme-toggle',
    standalone: true,
    imports: [
        MatButtonModule,
        MatIconModule,
        MatTooltipModule
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        <button mat-icon-button
                type="button"
                class="cy-theme-toggle"
                (click)="toggleTheme()"
                [matTooltip]="themeTooltip()"
                [attr.aria-label]="themeTooltip()">
            <mat-icon class="headerIcons">
                {{ isDarkTheme() ? 'light_mode' : 'dark_mode' }}
            </mat-icon>
        </button>
    `
})
class ThemeToggleComponent
{
    /**
     * @desc   - inject theme persistence service
     * @access - public
     * @param  - themeService : light and dark color mode
     * @return -
     */
    constructor
    (
        private themeService: ThemeService
    )
    {
    }

    /**
     * @desc   - whether dark mode is active
     * @access - public
     * @param  -
     * @return - true when dark mode is on
     */
    isDarkTheme(): boolean
    {
        let result;

        result = this.themeService.isDark();

        return result;
    }

    /**
     * @desc   - label for the header theme toggle
     * @access - public
     * @param  -
     * @return - tooltip for switching modes
     */
    themeTooltip(): string
    {
        let result;

        result = this.themeService.tooltip();

        return result;
    }

    /**
     * @desc   - switch between light and dark modes
     * @access - public
     * @param  -
     * @return -
     */
    toggleTheme(): void
    {
        this.themeService.toggle();

        return;
    }
}

export { ThemeToggleComponent };
